<template>
  <div>
    <loading :active.sync="loader" :can-cancel="false" :is-full-page="true" />
    <Header/>

    <div class="fade-in-right sticky-container">
      <ul class="sticky">
        <li>
          <div
              class="mt-4"
              @click="mostrarModalCargaMasiva()"
          >
            <img alt="carga" src="../../assets/icons/varios_archivos.svg" width="32" height="32" />
            <p style="font-weight: 600">
              <a style="color: #0663a1" target="_blank">
                Carga<br/>
                masiva<br/>
              </a>
            </p>
          </div>
        </li>
      </ul>
    </div>

    <b-card class="bCardAgenda">
      <div class="m-4">
        <b-row>
          <b-col></b-col>
          <b-col>
            <div class="barra-busqueda d-flex">
              <em class="buscar_outline_svg icon-dentalia-svg-2 ml-2" ></em>
              <b-form-input
                  class="input-filter"
                  size="md"
                  v-model="filtro"
                  placeholder="Búsqueda por clínica o por región"
                  @input="obtenerHorarios()"

              ></b-form-input>
            </div>
          </b-col>
          <b-col></b-col>
        </b-row>
        <div class="m-4 p-2" style="background-color: #008FFF; color: white; text-align: left; font-size: xx-large; border-radius: 10px">
          <span class="ml-4">Administración de horarios de clínica</span>
        </div>
        <div class="m-4">
          <b-table
              id="TablaHorariosClinica"
              thead-tr-class="columnasTablaSinColor"
              :items="horarios"
              :fields="columnas"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              style="font-weight: bold">
            <template v-slot:cell(listaNombreDias)="row">
              <div v-for="(listaDias, indexListaDias) in row.item.listaNombreDias" v-bind:key="indexListaDias">
                <div v-if="listaDias.length === 7">
                  <span>Lunes a domingo</span>
                  <em
                      v-if="row.item.listaSinOperacion && row.item.listaSinOperacion[indexListaDias]"
                      v-b-tooltip.hover="{ title: 'Cerrado', variant: 'danger' }"
                      class="fa fa-warning text-danger ml-2"
                      style="font-size: 16px;"
                  ></em>
                </div>
                <div v-else>
                  <b-row class="d-flex justify-content-center">
                    <b-col class=" m-0" cols="1.5" v-for="(dia, indexDia) in listaDias" v-bind:key="indexDia">
                      <span v-if="indexDia > 0 && indexDia < (listaDias.length - 2) && listaDias.length > 1">
                        , {{ dia }}
                      </span>
                      <span v-else-if="indexDia === (listaDias.length - 2) && listaDias.length > 1" class="pr-1">
                        {{ indexDia !== 0 ? ", " : "" }} {{ dia }} y
                      </span>
                      <span v-else>
                        {{ dia }}
                      </span>
                    </b-col>
                    <em
                        v-if="row.item.listaSinOperacion && row.item.listaSinOperacion[indexListaDias]"
                        v-b-tooltip.hover="{ title: 'Cerrado', variant: 'danger' }"
                        class="fa fa-warning text-danger ml-2"
                        style="font-size: 16px;"
                    ></em>
                  </b-row>
                </div>
                <hr v-if="row.item.listaNombreDias.length > 1 && row.item.listaNombreDias.length !== (indexListaDias + 1)">
              </div>
            </template>
            <template v-slot:cell(listaHorariosInicio)="row">
              <div v-for="(horaInicio, index) in row.item.listaHorariosInicio" v-bind:key="index">
                <span v-if="row.item.listaSinOperacion && row.item.listaSinOperacion[index]">
                  --:--
                </span>
                <span v-else>{{ horaInicio | formatoHoraEstandar }}</span>
                <hr v-if="row.item.listaHorariosInicio.length > 1 && row.item.listaNombreDias.length !== (index + 1)">
              </div>
            </template>
            <template v-slot:cell(listaHorariosCierre)="row">
              <div v-for="(horaCierre, index) in row.item.listaHorariosCierre" v-bind:key="index">
                <span v-if="row.item.listaSinOperacion && row.item.listaSinOperacion[index]">
                  --:--
                </span>
                <span v-else>{{ horaCierre | formatoHoraEstandar }}</span>
                <hr v-if="row.item.listaHorariosCierre.length > 1 && row.item.listaNombreDias.length !== (index + 1)">
              </div>
            </template>
            <template v-slot:cell(editar)="row">
              <b-button
                  title="Editar horario"
                  size="sm"
                  variant="outline-warning"
                  @click="editar(row.item)"
                  pill
              ><em class="fa fa-pencil"></em></b-button>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="horarios.length === 0" variant="warning" show>No encontramos resultados para tu búsqueda. Por favor, intenta nuevamente</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                align="center"
                v-model="paginaActual"
                :total-rows="horarios.length"
                :per-page="registrosPorPagina"
            ></b-pagination>
          </b-col>
        </div>
      </div>
    </b-card>
    <EditarHorarioModal ref="modalHorario" @guardar="actualizarHorarios" />
    <CargaMasivaModal
      ref="cargaMasivaModal"
      @finalizar="finalizarCarga"
    />
  </div>
</template>

<script>

import Header from "@/components/Header.vue";
import EditarHorarioModal from "@/components/horarioClinica/edicionManual/EditarHorarioModal.vue";
import CargaMasivaModal from "@/components/horarioClinica/cargaMasiva/CargaMasivaModal.vue";

export default {
  name: "horarioClinica",
  props: {},
  components: {
    Header,
    EditarHorarioModal,
    CargaMasivaModal
  },
  data: () =>({
    horarios: [],
    columnas: [
      {key: "nombreZona", label:"REGIÓN"},
      {key: "nombreClinica", label:"Clínica"},
      {key: "listaNombreDias", label:"Día"},
      {key: "listaHorariosInicio", label:"Horario de apertura"},
      {key: "listaHorariosCierre", label:"Horario de cierre"},
      {key: "editar", label:""},
    ],
    registrosPorPagina: 10,
    paginaActual: 1,
    loader: false,
    filtro: '',
  }),
  computed: {},
  created() {
    this.obtenerHorarios();
  },
  methods: {
    obtenerHorarios(){
      this.loader = true;
      this.$http.post(this.$api + "horarioCLinica/obtenerHorariosClinica", {filtroClinicaZona: this.filtro}).then((respuesta) => {
        if (respuesta.data) {
          this.horarios = respuesta.data.data;
        }
      }).finally(() => {
        this.loader = false;
      });
    },

    editar(horario){
      this.$refs.modalHorario.abrirModal(horario.idClinica);
    },
    actualizarHorarios(horarios, horariosDiferentes) {
      this.loader = true;
      const mensaje = horariosDiferentes
        ? 'Los horarios de apertura y cierre son diferentes en algunos días'
        : 'Los horarios de apertura y cierre son iguales en todos los días';

      this.$http.post(this.$api + "horarioCLinica/editar", horarios)
      .then(() => {
        this.loader = false;
        this.$swal({
          icon: 'success',
          title: 'Horario de clínica guardado',
          text: mensaje,
          confirmButtonText: 'Aceptar',
          returnFocus: false,
          customClass: {
            confirmButton: 'btn btn-secondary rounded-pill'
          }
        });
        this.$refs.modalHorario.cerrarModal();
        this.obtenerHorarios();
      }).catch((error) => {
        const mensajeError = error.response?.data?.message ||
                            error.response?.data?.mensaje ||
                            error.response?.data ||
                            'Error al guardar los horarios';
        this.$swal({
          icon: 'warning',
          title: 'Atención',
          text: mensajeError,
          confirmButtonText: 'OK',
          returnFocus: false,
          customClass: {
            confirmButton: 'btn btn-secondary rounded-pill'
          }
        });
      }).finally(() => {
        this.loader = false;
      });
    },

    mostrarModalCargaMasiva(){
      this.$refs.cargaMasivaModal.abrirModal();
    },
    finalizarCarga() {
      this.obtenerHorarios();
    }
  },
}
</script>


<style scoped>

.barra-busqueda {
  border-width: 1px;
  border-style: solid;
  border-color: #858585;
  background: #ffffff;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 10px;
  text-align: left;
  align-items: center;

  min-width: 100px !important;
}

.fade-in-right {
  -webkit-animation: fade-in-right 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: fade-in-right 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

@-webkit-keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

.sticky-container {
  position: fixed;
  right: 0px;
  top: 50px;

  z-index: 1100;
}

.sticky li {
  border-radius: 20px 0px 0px 20px;
  box-shadow: -10px 11px 17px -6px rgba(0, 0, 0, 0.12);

  list-style-type: none;
  background-color: #fff;
  color: #efefef;
  height: 650px;
  padding: 10px;
  margin: 0px 0px 1px 0px;
}

.sticky li p {
  padding-top: 5px;
  margin: 0px;
  line-height: 16px;
  font-size: 11px;
}
.sticky li p a {
  text-decoration: none;
  color: #2c3539;
}
.sticky li p a:hover {
  text-decoration: underline;
}

.contenedor {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.warning-icon {
  margin-left: 4px;
  font-size: 14px;
}
</style>